import {
  Autocomplete as MuiAutocomplete,
  AutocompleteProps as MuiAutocompleteProps,
  AutocompleteRenderInputParams,
  SxProps,
  Theme,
} from "@mui/material";
import Input from "./Input";

type BaseAutocompleteProps<
  T,
  Multiple extends boolean | undefined = false,
> = Omit<
  MuiAutocompleteProps<T, Multiple, false | undefined, false | undefined>,
  "renderInput"
> & {
  label?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode;
};

function Autocomplete<T, Multiple extends boolean | undefined = false>({
  label,
  placeholder,
  error,
  helperText,
  disablePortal = true,
  sx,
  renderInput,
  ...rest
}: BaseAutocompleteProps<T, Multiple>) {
  return (
    <MuiAutocomplete
      disablePortal={disablePortal}
      sx={{ marginY: "0.4rem", ...sx } as SxProps<Theme>}
      renderInput={(params) =>
        renderInput
          ? renderInput(params)
          : (
              <Input
                {...params}
                label={label}
                placeholder={placeholder}
                error={error}
                helperText={helperText}
                sx={{ marginY: 0 }}
              />
            )
      }
      {...rest}
    />
  );
}

export default Autocomplete;
